module.exports = __webpack_public_path__ + "static/media/OpenSans-Italic.f6238deb.ttf";